// src/avatarSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import fetchJsonDataOfCourseInfo from '../../api/DownloadCourseInfo';

// Define an async thunk for fetching avatar
export const fetchItems = createAsyncThunk('avatar/fetchItems', async ({ url }) => {
    const response = await fetchJsonDataOfCourseInfo(url); // replace with your API URL
    return response.data;
});

// Create the slice
const avatarSlice = createSlice({
    name: 'avatar',
    initialState: {
        avatar: [],
        loading: false,
        error: null,
    },
    reducers: {
        // You can define regular synchronous reducers here if needed
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchItems.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchItems.fulfilled, (state, action) => {
                state.loading = false;
                state.avatar = action.payload;
                state.error = null;
            })
            .addCase(fetchItems.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

// Export the async thunk and the reducer
export default avatarSlice.reducer;
